<template>
  <div class="containerAddMaterial">
    <a-modal title="选择文件" :visible="visible" width="600px" @cancel="clear" @ok="confirm">
      <a-upload-dragger
        name="file"
        :multiple="true"
        :maxSize="10"
        :file-list="fileList"
        :beforeUpload="beforeUpload"
        :remove="handleRemove"
        @change="handleChange"
      >
        <!-- action="/jpaas-jiop-web-server/interface/usermaterial/uploadFile" -->
        <p class="ant-upload-drag-icon">
          <a-icon type="plus" :style="uploadStyle" />
        </p>
        <p class="ant-upload-text">
          将文件拖拽到此处
        </p>
        <p class="ant-upload-text">
          或者点击<a>本地上传</a>
        </p>
        <p class="ant-upload-text">最多支持10个文件同时上传</p>
      </a-upload-dragger>
    </a-modal>
  </div>
</template>

<script>
import { jiopAPI } from '@/api/jiopweb/jiop'
export default {
  name: 'AddMaterial',
  data () {
    return {
      visible: false,
      timeOut: null,
      timeOutS: null,
      uploadStyle: 'color: #999999; font-size: 30px;',
      fileList: []
    }
  },
  methods: {
    handlePreview () {
    },
    open () {
      this.fileList = []
      this.visible = true
    },
    clear () {
      this.fileList = []
      this.visible = false
    },
    confirm () {
      if (this.fileList.length < 1) {
        this.$message.warning('请先上传文件')
        return
      }
      this.fileList.forEach(item => {
        const formData = new FormData()
        formData.append('file', item)
        formData.append('appType', '1')
        formData.append('userId', '')
        jiopAPI.usermaterialuploadFile(formData).then(val => {
          if (val.success) {
            this.$parent.init()
            this.$message.success('上传成功')
          }
          // }
        })
      })
      this.visible = false
    },
    handleChange (file) {
    },
    handleRemove (file) {
      this.fileList.splice(this.fileList.indexOf(file), 1)
    },
    beforeUpload (file, fileList) {
      if (this.fileList.length > 9) {
        this.$message.warning('最多支持10个文件同时上传')
        return true
      } else {
        this.fileList.push(file)
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ant-upload-drag-icon {
  width: 58px;
  height: 58px;
  background-color: #F5F5F5;
  margin: auto;
  margin-top: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .ant-upload.ant-upload-drag {
  border: none;
  background-color: white;
}
/deep/ .ant-upload.ant-upload-drag p.ant-upload-text {
  color: #333333;
  margin-bottom: 8px;;
  font-size: 14px;
}
/deep/ .ant-modal-body {
  padding-bottom: 34px;
}
</style>
